module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/logo-coj-ja-c8d1142baaf7b7b340ea9be11d057e37.svg";